/** @typedef {import('../../shared/OfferService/OffersProps').default} Props */

import { translate } from '../../Internationalization';
import AdminVendors from './ViewOffers/AdminVendors';
import flags from '../../../shared/Flags';
import images from '../../../config/local/images';
import LinkButton from '../../../shared/LinkButton';
import paths from '../../../config/local/paths';
import React from 'react';
import useAuth from '../../../Hooks/Shared/useAuth/useAuth';
import useGetAdminVendors from '../../../Hooks/Admin/Getters/useGetAdminVendors/useGetAdminVendors';
import useIsGated from '../../../Hooks/Shared/useIsGated/useIsGated';
import VendorExclusivity from '../../shared/VendorExclusivity';

const view = 'group';

/** @returns {JSX.Element} */
export default function ViewGroupOffers() {
	const authContext = useAuth();
	// vendors are unlocked for admins as long as at least one group has the subscription
	const gated = useIsGated(flags.vendor.add, { role: 'admin' });
	const { total } = useGetAdminVendors(view, 1, gated.isGated);

	return (
		<React.Fragment>
			<header className="mt-10 mb-6 md:flex justify-between items-center">
				<h1 className="hl-ms-6 mb-6 md:mb-0">
					{translate('admin.pages.offers.groups_view.title')}{' '}
					{total ? `(${total})` : ''}
				</h1>

				<section className="button-group">
					<LinkButton
						icon={images.icons.eye}
						to={paths.app.admin.offers.view}
					>
						{authContext.roles.includes('manager')
							? translate('admin.pages.offers.view.view_agent')
							: translate('admin.pages.offers.view.view_domain')}
					</LinkButton>

					{!gated.isGated ? (
						<LinkButton
							icon={images.icons.plus}
							to={paths.app.admin.offers.add}
						>
							{translate('global.offers.add_title')}
						</LinkButton>
					) : null}
				</section>
			</header>

			{/* @ts-ignore */}
			<VendorExclusivity type="administrator" />

			<AdminVendors view={view} />
		</React.Fragment>
	);
}
